export default __webpack_public_path__ + "static/media/ic_forward_arrow.c1dc430b.svg";